import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/indexS2'),
  },
  // {
  //   path: '/location',
  //   redirect: '/location/s2',
  //   name: 'S1S',
  //   children: [{
  //     path: 's1',
  //     name: 'S1',
  //     component: () => import('@/views/indexS1'),
  //   },
  //   ],
  // },
  {
    path: '/s1',
    name: 'S1',
    component: () => import('@/views/indexS1'),
  },
  {
    path: '/s2',
    name: 'S2',
    component: () => import('@/views/indexS2'),
  },
  {
    path: '/s3',
    name: 'S3',
    component: () => import('@/views/indexS3'),
  },
  {
    path: '/a1',
    name: 'A1',
    component: () => import('@/views/indexA1'),
  },
  {
    path: '/a2',
    name: 'A2',
    component: () => import('@/views/indexS1'),
  },
  {
    path: '/a3',
    name: 'A3',
    component: () => import('@/views/indexA3'),
  },
  {
    path: '/a4',
    name: 'A4',
    component: () => import('@/views/indexA4'),
  },
  {
    path: '/a5',
    name: 'A5',
    component: () => import('@/views/indexA5'),
  },
  {
    path: '/a7',
    name: 'A7',
    component: () => import('@/views/indexA7'),
  },
  {
    path: '/a8',
    name: 'A8',
    component: () => import('@/views/indexA8'),
  },
  {
    path: '/b2',
    name: 'B2',
    component: () => import('@/views/indexB2'),
  },
  {
    path: '/c1f',
    name: 'C1f',
    component: () => import('@/views/indexC1f'),
  },
  {
    path: '/c1b',
    name: 'C1b',
    component: () => import('@/views/indexC1b'),
  },
  {
    path: '/cd4',
    name: 'CD4',
    component: () => import('@/views/indexCD4'),
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('@/views/component/custom-map'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
